module.exports = __webpack_public_path__ + "fonts/Chivo-Regular.47b6c66.woff2";